import { Alert, AlertTitle, Link, Box, Typography } from "@mui/material";

// COMPONENTS
import Navbar from "../components/Navbar";

// HOME
export default function ErrorPage() {
    return (
        <Box sx={{ height: '100vh', overflowX: 'hidden', overflowY: 'scroll' }}>
            <Navbar />

            {/* MAIN BODY */}
            <Box component="main" sx={{ px: 5, pb: 2 }}>
                <Alert severity="error" sx={{ mt: 3 }}>
                    <AlertTitle>Error 404</AlertTitle>

                    <Typography variant="subtitle1">
                        This page could not be found! If you believe this is an error, please submit a <b>Bug Report</b> ticket on
                        our <Link href="https://discord.gg/productionrp" target="_blank">discord</Link>!
                    </Typography>
                </Alert>
            </Box>
        </Box>
    )
}
